import i18next from 'i18next'

import { API } from '@/api'
import { message, Modal } from '@/components'
import { formatBytes } from '@/utils/formatter'

import { getSnapshotShareErrorMessage, getSnapshotShareResultCode } from '../utils/shareResult'

interface ShareToTeamModalOptions {
  snapshotId: string
  snapshotName: string
  ownerName: string
  sizeInBytes: number
  teamResID: string
  onSuccess: () => void
}

export function showShareToTeamModal({
  snapshotId,
  snapshotName,
  ownerName,
  sizeInBytes,
  teamResID,
  onSuccess,
}: ShareToTeamModalOptions) {
  Modal.confirm({
    title: 'Share with Team',
    content: (
      <div className="flex flex-col gap-4 text-primary">
        <div className="t-sb">Do you want to share this snapshot with your team?</div>
        <div className="bg-neutral-50 rounded-lg p-4 flex flex-col gap-3">
          <div className="h6">{snapshotName || snapshotId}</div>
          <div className="border-t border-neutral-200 pt-3 grid grid-cols-3 gap-4">
            <div>
              <div className="t-xs text-secondary">ID</div>
              <div className="t-sb">{snapshotId}</div>
            </div>
            <div>
              <div className="t-xs text-secondary">Owner</div>
              <div className="t-sb">{ownerName || '-'}</div>
            </div>
            <div>
              <div className="t-xs text-secondary">Size</div>
              <div className="t-sb">{formatBytes(sizeInBytes)}</div>
            </div>
          </div>
        </div>
      </div>
    ),
    confirmBtnCfg: {
      type: 'secondary',
      text: 'Share',
    },
    className: 'w-[640px]',
  }).then(async () => {
    try {
      const res = await API.importTeamSnapshot(
        {
          res_id: teamResID,
          snap_res_id: snapshotId,
        },
        { errMsg: false, noErrMsg: true },
      )
      if (getSnapshotShareResultCode(res) === 0) {
        message.success(
          i18next.t('teamSnapshot.share.success', {
            defaultValue: 'Snapshot shared to team successfully',
          }),
        )
        onSuccess()
      } else {
        message.error(getSnapshotShareErrorMessage(res))
      }
    } catch (error) {
      console.error('Failed to share snapshot:', error)
      message.error(getSnapshotShareErrorMessage(error))
    }
  })
}
